import { uniqueId } from "lodash";
import reactStringReplace from "react-string-replace";

import { SpeakerColorScheme } from "../../../constants";
import SpeakerIcon from "./SpeakerIcon";

const highlightBrandWord = {
  color: "#000000",
  backgroundColor: "#f9d4e6",
  padding: "3px",
};

const highlightProductWord = {
  color: "#000000",
  backgroundColor: "#d5f1ee",
  padding: "3px",
};

const DownloadSpeakerPDF = ({
  video,
  productName,
  brandName,
  showTimestamp,
  componentRef,
  completeTranscript,
}) => {
  return (
    <div ref={componentRef} style={{ padding: "20px", paddingLeft: "0px" }}>
      {video.transcription_text
        ? completeTranscript.map(
            ({ start_time, content, speaker }, i, array) => {
              let replacedText;
              replacedText = reactStringReplace(
                content,
                brandName,
                (match, i) => (
                  <span style={highlightBrandWord} key={uniqueId()}>
                    {match}
                  </span>
                )
              );

              productName?.forEach(
                (element) =>
                  (replacedText = reactStringReplace(
                    replacedText,
                    element.name,
                    (match, i) => (
                      <span key={uniqueId()} style={highlightProductWord}>
                        {match}
                      </span>
                    )
                  ))
              );

              if (i === 0 || speaker !== array[i - 1].speaker) {
                return (
                  <div
                    key={i}
                    className="transcript-sentence d-flex gap-1"
                    style={i === 0 ? {} : { marginTop: "30px" }}
                  >
                    <div
                      style={{ minWidth: "90px", paddingTop: "-2px" }}
                      className="d-flex flex-column text-center align-items-center"
                    >
                      <SpeakerIcon
                        circleColor={SpeakerColorScheme[speaker][0]}
                        pathColor={SpeakerColorScheme[speaker][1]}
                      />
                      <span style={{ fontSize: "10px", color: "#666179" }}>
                        Speaker {speaker + 1}
                      </span>
                    </div>
                    {showTimestamp && (
                      <div
                        style={{
                          minWidth: "70px",
                          paddingTop: "8px",
                          color: "#6B727A",
                        }}
                      >
                        {start_time}
                      </div>
                    )}
                    <div
                      style={{
                        lineHeight: "32.34px",
                        color: "#000000",
                      }}
                    >
                      {replacedText}
                    </div>
                  </div>
                );
              } else {
                return (
                  <div key={i} className="transcript-sentence d-flex gap-1">
                    <div style={{ minWidth: "90px" }}></div>
                    {showTimestamp && (
                      <div
                        style={{
                          minWidth: "70px",
                          color: "#6B727A",
                          marginTop: "6px",
                        }}
                      >
                        {start_time}
                      </div>
                    )}
                    <div style={{ lineHeight: "32.34px", color: "#000000" }}>
                      {replacedText}
                    </div>
                  </div>
                );
              }
            }
          )
        : "No Transcript Found"}
    </div>
  );
};
export default DownloadSpeakerPDF;
